import assetPath from '/opt/actions-runner/_work/crate/crate/brewery-packages/xds/super-ellipse/src/assets/super-ellipse-mask.svg';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')